export default "__VITE_ASSET__DgiYRJXX__"